import { render, staticRenderFns } from "./user-discover-ebooks-list.vue?vue&type=template&id=1c43fd30&"
import script from "./user-discover-ebooks-list.vue?vue&type=script&lang=js&"
export * from "./user-discover-ebooks-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports